// src/components/admin/lead-detail/LeadInteractionsTable.js
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/ui/table";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";
import { format } from "date-fns";
import { CheckCircle2, XCircle } from "lucide-react";

export const LeadInteractionsTable = ({ data = [] }) => {
  const YesNoIcon = ({ value }) => {
    const isYes = value && value.toLowerCase() === "yes";
    return isYes ? (
      <CheckCircle2 className="w-5 h-5 text-green-600" />
    ) : (
      <XCircle className="w-5 h-5 text-gray-400" />
    );
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Seller Interactions & Purchases</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Seller</TableHead>
              <TableHead className="text-center">Checked Profile</TableHead>
              <TableHead className="text-center">Quote Requested</TableHead>
              <TableHead>Purchased (Coins)</TableHead>
              <TableHead>Purchase Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.seller_profile_id}>
                  <TableCell>
                    <Link
                      to={`/admin/sellers/${row.seller_profile_id}/view`}
                      className="font-medium text-primary hover:underline"
                    >
                      {row.seller_name}
                    </Link>
                    <div className="text-xs text-muted-foreground">
                      ID: {row.seller_profile_id}
                    </div>
                  </TableCell>
                  <TableCell className="text-center">
                    <YesNoIcon value={row.checked_profile} />
                  </TableCell>
                  <TableCell className="text-center">
                    <YesNoIcon value={row.asked_for_quote} />
                  </TableCell>
                  <TableCell>{row.purchased_coins ?? "N/A"}</TableCell>
                  <TableCell>
                    {row.purchase_timestamp
                      ? format(new Date(row.purchase_timestamp), "PPp")
                      : "N/A"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className="text-center">
                  No seller interactions or purchases recorded for this lead.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
